export default __webpack_public_path__ + "static/media/twitterNew.449dbe97.svg";